import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control/index'

const DraftPublishedModal = (props) => {
  const { enableModal, onClose } = props

  return (
    <Modal isOpen={enableModal} size='medium'>
      <ModalHeader title="Your draft can't be deleted." onClose={onClose} />
      <ModalBody>
        This article has already been published, so we could not delete this draft.
      </ModalBody>
      <ModalFooter>
        <ButtonControl
          title='Go back to homepage'
          variant='primary'
          onClick={() => { window.location.assign(window.location.origin + '/moderation/overview') }}
        />
      </ModalFooter>
    </Modal>
  )
}

export default DraftPublishedModal
